<template>
  <div v-if="lastLink">
    <div class="mobile-breadcrumb">
      <router-link :to="{ name: lastLink.route }" class="breadcrumb__item breadcrumb__item--linked">
        <z-icon :icon="['far', 'chevron-left']" size="medium" color="primary" class="breadcrumb__link-arrow" />
        <z-text tag="span" size="small" color="interactive" weight="bold">
          {{ lastLink.label }}
        </z-text>
      </router-link>
    </div>
    <div class="desktop-breadcrumb">
      <div v-for="(breadcrumb, index) in breadcrumbList" :key="index">
        <router-link
          v-if="!!breadcrumb.route"
          :to="{ name: breadcrumb.route }"
          class="breadcrumb__item breadcrumb__item--linked"
        >
          {{ breadcrumb.label }}
        </router-link>
        <span v-else class="breadcrumb__item">
          {{ breadcrumb.label }}
        </span>
        <span class="breadcrumb__divider" v-if="index !== breadcrumbList.length - 1">/</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.mobile-breadcrumb {
  @media (min-width: $screen-md-min) {
    display: none;
  }
}

.desktop-breadcrumb {
  align-items: center;
  display: flex;

  @media (max-width: $screen-sm-max) {
    display: none;
  }
}

.breadcrumb__item {
  font-size: rem(13);
  line-height: rem(20);
}

.breadcrumb__item--linked {
  color: var(--color-primary);
  font-weight: var(--font-weight-bold);
  text-decoration: none;
}

.breadcrumb__link-arrow {
  margin-right: var(--space-extra-small);
}

.breadcrumb__divider {
  margin-left: var(--space-extra-small);
  margin-right: var(--space-small);
}
</style>

<script>
export default {
  data() {
    return {
      breadcrumbList: [],
    };
  },
  computed: {
    breadcrumbConfig() {
      return this.$route.meta.breadcrumb;
    },
    lastLink() {
      const links = this.breadcrumbList.filter((breadcrumb) => !!breadcrumb.route);
      if (!!links && links.length > 0) {
        return links[links.length - 1];
      }
      return null;
    },
  },
  methods: {
    loadBreadcrumbList() {
      if (this.breadcrumbConfig) {
        this.breadcrumbList = this.breadcrumbConfig[this.$route.query.from] || this.breadcrumbConfig.default;
      } else {
        console.error('Breadcrumb links is not defined for the current route. Check router config.');
      }
    },
  },
  mounted() {
    this.loadBreadcrumbList();
  },
};
</script>
